module.exports = __webpack_public_path__ + "media/images/review/sample-photo2-b82537a6e22a8b4e6a816c5cbc42e447.png";